import React, { memo } from "react"
import { ButtonProps } from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import IconButton from "components/IconButton"
import ChevronLeft from "components/Icons/ChevronLeft.icon"
import ChevronRight from "components/Icons/ChevronRight.icon"
import Grid from "@material-ui/core/Grid"
import { StyledTimeSwitchTitle, StyledTimeSwitchSubtitle, StyledGrid } from "./style"

export interface ITimeSwitchProps {
  title: string
  subTitle?: string
  iconColor?: ButtonProps["color"]
  onDateChange: (status: TimeStatus) => void
}

export enum TimeStatus {
  FUTURE = "add",
  PAST = "decrease",
}

function TimeSwitch({ title, subTitle, iconColor = "secondary", onDateChange }: ITimeSwitchProps) {
  const onDateChangePast = () => onDateChange(TimeStatus.PAST)
  const onDateChangeFuture = () => onDateChange(TimeStatus.FUTURE)

  return (
    <StyledGrid container={true} spacing={1} alignItems="center">
      <Grid item={true}>
        <IconButton color={iconColor} onClick={onDateChangePast}>
          <ChevronLeft />
        </IconButton>
        <IconButton color={iconColor} onClick={onDateChangeFuture}>
          <ChevronRight />
        </IconButton>
      </Grid>
      <Grid item={true}>
        <Typography variant="h2" component="div" align="center">
          <StyledTimeSwitchTitle>{title}</StyledTimeSwitchTitle>
        </Typography>
        {subTitle && <StyledTimeSwitchSubtitle variant="caption">{subTitle}</StyledTimeSwitchSubtitle>}
      </Grid>
    </StyledGrid>
  )
}

export default memo(TimeSwitch)
